import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  const quickLinks = [
    { label: t('nav_guides'), href: '/#articles' },
    { label: t('nav_reviews'), href: '/allchinabuy-review' },
    { label: t('nav_shipping'), href: '/allchinabuy-shipping-cost' },
    { label: t('nav_about'), href: '/about' },
  ];

  const resourceLinks = [
    { label: t('article_allchinabuy_spreadsheet_guide'), href: '/allchinabuy-spreadsheet-complete-guide' },
    { label: t('article_allchinabuy_review'), href: '/allchinabuy-review' },
    { label: t('article_shipping_cost'), href: '/allchinabuy-shipping-cost' },
    { label: t('article_allchinabuy_coupon'), href: '/allchinabuy-coupon' },
  ];

  const legalLinks = [
    { label: t('footer_privacy'), href: '/privacy' },
    { label: t('footer_terms'), href: '/terms' },
    { label: t('footer_disclaimer'), href: '/disclaimer' },
  ];

  return (
    <footer className="bg-stone-900 text-stone-300">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-stone-700 flex items-center justify-center">
                <i className="ri-shopping-bag-3-line text-white text-sm"></i>
              </div>
              <span className="text-lg font-semibold text-white tracking-tight">AllChinaBuy</span>
            </div>
            <p className="text-sm text-stone-400 leading-relaxed">{t('footer_desc')}</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">{t('footer_links')}</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-stone-400 hover:text-white transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">{t('footer_resources')}</h4>
            <ul className="space-y-2.5">
              {resourceLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-stone-400 hover:text-white transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">{t('footer_legal')}</h4>
            <ul className="space-y-2.5">
              {legalLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-stone-400 hover:text-white transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-stone-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-stone-500 text-center sm:text-left">
              {t('footer_copyright')}
            </p>
            <div className="flex items-center gap-3">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-stone-500 hover:text-white transition-colors cursor-pointer">
                <i className="ri-shopping-cart-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}